module.exports = __webpack_public_path__ + "media/images/tyre-tread-fade-3d3d9cf40a69edcf925dce5064253496.png";